import React from 'react';
import { identity } from 'lodash';

import WatchlistTickerAssetDataQuery from 'buyside/graphql/queries/WatchlistTickerAssetData.graphql';
import SecuritySearchQuery from 'buyside/graphql/queries/SecuritySearch.graphql';

import Autocomplete from 'buyside/components/presentation/Autocomplete/autocomplete';

const formatSuggestion = obj => {
  if (obj.ticker) {
    return {
      label: `${obj.ticker} - ${obj.entity_name}`,
      id: obj.id
    };
  }
  return { label: obj.entity_name, id: obj.id };
};
class TickerSearchAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };

    this.handleAutocomplete = this.handleAutocomplete.bind(this);
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  handleAutocomplete(results) {
    const suggestions = [
      !!results.exact_matches.length && {
        title: 'Exact Ticker Match',
        data: results.exact_matches,
        suggestions: results.exact_matches.map(result => formatSuggestion(result))
      },
      !!results.matching_tickers.length && {
        title: 'Partially Matching Tickers',
        data: results.matching_tickers,
        suggestions: results.matching_tickers.map(result => formatSuggestion(result))
      },
      !!results.matching_names.length && {
        title: 'Matching Companies by Name',
        data: results.matching_names,
        suggestions: results.matching_names.map(result => formatSuggestion(result))
      }
    ].filter(identity);
    this.setState({ loading: false });
    this.props.updateSuggestions(suggestions);
  }

  selectIntercept(tickerValue, selectedItem) {
    const { client, setParentState } = this.props;

    setParentState({
      isValidTicker: true,
      loadingAsset: true,
      selectedItem,
      tickerValue
    });
    client
      .query({ query: WatchlistTickerAssetDataQuery, variables: { id: selectedItem.id } })
      .then(({ data }) => {
        setParentState({ assetData: data.watchlistTickerAssetData, loadingAsset: false });
      });
  }

  changeIntercept(searchTerm, reason) {
    const { client, setParentState } = this.props;

    if (reason === 'input-changed') {
      this.setState({ loading: true });
      setParentState({ isValidTicker: false });
      client
        .query({
          query: SecuritySearchQuery,
          variables: { query: searchTerm, assetClass: 'Equity', skip: false }
        })
        .then(res => {
          const results = JSON.parse(res.data.securitySearch);
          this.handleAutocomplete(results);
        });
    }
  }

  render() {
    const { tickerValue, suggestions } = this.props;

    return (
      <Autocomplete
        selectIntercept={this.selectIntercept}
        changeIntercept={this.changeIntercept}
        suggestions={suggestions}
        loading={this.state.loading}
        initialValue={tickerValue}
        debounce
        inputProps={{ id: 'tickerAutocomplete' }}
        autosuggestOptions={{
          focusInputOnSuggestionClick: false,
          multiSection: true
        }}
      />
    );
  }
}

export default TickerSearchAutoComplete;
